import {
  AspectRatio,
  Flex,
  Heading,
  SimpleGrid,
  VStack,
} from "@chakra-ui/react";
import { LottieReact } from "@lottielab/lottie-player";

import { HoverCardWithLink } from "@/components/hover-card-with-link";
import {
  AppRoute,
  isPPDeprecated,
  STAKING_URL,
  SWAP_URL,
} from "@/constants/shared";

type Action = {
  href: string;
  lottie: string;
  mobileIcon: React.ReactNode;
  label: string;
  ppDeprecated?: boolean;
};

const allActions: Action[] = [
  {
    href: AppRoute.BridgeWithDefaults,
    lottie: "https://cdn.lottielab.com/l/7oyfUv4GBA14cy.json",
    mobileIcon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="35"
        height="35"
        viewBox="0 0 35 35"
        fill="none"
      >
        <path
          d="M9.03125 7.20947H27.5938C28.4143 7.20947 29.2012 7.53542 29.7814 8.11561C30.3616 8.6958 30.6875 9.48271 30.6875 10.3032V24.2251C30.6875 24.6354 30.5245 25.0288 30.2344 25.3189C29.9443 25.609 29.5509 25.772 29.1406 25.772H26.0469C25.6366 25.772 25.2432 25.609 24.9531 25.3189C24.663 25.0288 24.5 24.6354 24.5 24.2251V21.1313C24.5 19.4903 23.8481 17.9165 22.6877 16.7561C21.5273 15.5957 19.9535 14.9438 18.3125 14.9438C16.6715 14.9438 15.0977 15.5957 13.9373 16.7561C12.7769 17.9165 12.125 19.4903 12.125 21.1313V24.2251C12.125 24.6354 11.962 25.0288 11.6719 25.3189C11.3818 25.609 10.9884 25.772 10.5781 25.772H7.48438C7.07412 25.772 6.68066 25.609 6.39057 25.3189C6.10047 25.0288 5.9375 24.6354 5.9375 24.2251V10.3032C5.9375 9.48271 6.26345 8.6958 6.84364 8.11561C7.42383 7.53542 8.21074 7.20947 9.03125 7.20947Z"
          fill="#747474"
          stroke="#747474"
          strokeWidth="2"
        />
      </svg>
    ),
    label: "Bridge",
  },
  {
    href: SWAP_URL,
    lottie: "https://cdn.lottielab.com/l/AgP8tNat8izUBm.json",
    mobileIcon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="35"
        height="35"
        viewBox="0 0 35 35"
        fill="none"
      >
        <path
          d="M14.2969 5.52197L6.54222 13.2766C6.29023 13.5286 6.4687 13.9595 6.82506 13.9595H29.4844"
          stroke="#747474"
          strokeWidth="4"
          strokeLinecap="round"
        />
        <path
          d="M21.0469 29.147L28.8015 21.3923C29.0535 21.1403 28.8751 20.7095 28.5187 20.7095H5.85938"
          stroke="#747474"
          strokeWidth="4"
          strokeLinecap="round"
        />
      </svg>
    ),
    label: "Swap",
  },
  {
    href: STAKING_URL,
    lottie: "https://cdn.lottielab.com/l/23SHqH3DDzHgvT.json",
    mobileIcon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="35"
        height="35"
        viewBox="0 0 35 35"
        fill="none"
      >
        <path
          d="M23.5421 12.4212V22.1121L19.7378 18.2762V8.58526L23.5421 12.4212Z"
          fill="#747474"
        />
        <path
          d="M12.9361 23.1207H22.5423L18.7399 19.2829H9.13371L12.9361 23.1207Z"
          fill="#747474"
        />
        <path
          d="M28.9491 28.6093V17.8758L25.1448 14.0399V24.7734L14.5407 24.7375L18.343 28.5754L28.9471 28.6112"
          fill="#747474"
        />
        <path
          d="M4.24988 3.83632L4.24988 14.5698L8.05417 18.4057L8.05417 7.67221L18.6583 7.70804L14.856 3.87018L4.2519 3.83435"
          fill="#747474"
        />
        <path
          d="M29.9549 30.6477L27.7966 28.4703L28.8449 27.4128L31.0032 29.5901L31.2499 30.8344L29.9549 30.6477Z"
          fill="#747474"
        />
      </svg>
    ),
    label: "Stake",
  },
  isPPDeprecated
    ? {
        href: "https://app.nest.credit",
        lottie: "https://cdn.lottielab.com/l/DBvPAMyq8ZP6xt.json",
        mobileIcon: (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="35"
            height="35"
            viewBox="0 0 20 21"
            fill="none"
          >
            <path
              d="M12.589 0.860915L10.6158 0.333984L8.95297 6.51878L7.45172 0.935105L5.47847 1.46204L7.10048 7.49478L3.06044 3.46848L1.61593 4.90808L6.04735 9.32449L0.528725 7.85079L0 9.81729L6.02979 11.4275C5.96076 11.1307 5.92423 10.8215 5.92423 10.5038C5.92423 8.25504 7.75345 6.43203 10.0099 6.43203C12.2664 6.43203 14.0956 8.25504 14.0956 10.5038C14.0956 10.8195 14.0595 11.1268 13.9913 11.4218L19.4713 12.8851L20 10.9186L13.9462 9.30204L19.4652 7.82824L18.9365 5.86173L12.883 7.47823L16.923 3.45195L15.4785 2.01235L11.1085 6.36748L12.589 0.860915Z"
              fill="#747474"
            />
            <path
              d="M13.9856 11.4447C13.8164 12.1575 13.4592 12.7978 12.9692 13.3109L16.9392 17.2675L18.3837 15.8279L13.9856 11.4447Z"
              fill="#747474"
            />
            <path
              d="M12.9291 13.3523C12.4331 13.8571 11.8063 14.2339 11.1034 14.428L12.548 19.801L14.5212 19.2741L12.9291 13.3523Z"
              fill="#747474"
            />
            <path
              d="M11.0297 14.4477C10.7036 14.5312 10.3618 14.5756 10.0096 14.5756C9.63219 14.5756 9.26675 14.5246 8.91982 14.4292L7.47391 19.8071L9.44711 20.334L11.0297 14.4477Z"
              fill="#747474"
            />
            <path
              d="M8.85005 14.4093C8.1579 14.2055 7.54226 13.824 7.05641 13.3177L3.07665 17.284L4.52115 18.7236L8.85005 14.4093Z"
              fill="#747474"
            />
            <path
              d="M7.02361 13.2826C6.54609 12.7731 6.19826 12.1413 6.03269 11.4395L0.534837 12.9077L1.06356 14.8742L7.02361 13.2826Z"
              fill="#747474"
            />
          </svg>
        ),
        label: "Earn",
      }
    : {
        href: AppRoute.Quests,
        lottie: "https://cdn.lottielab.com/l/7Ayz8W2GKeCbgo.json",
        mobileIcon: (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="35"
            height="35"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              d="M23.5 9.70156L12.7635 13.3588C12.6019 13.4067 12.4403 13.4067 12.3027 13.3588L1.53024 9.70156C0.915252 9.50968 0.915252 8.73968 1.53024 8.54781L12.2547 4.7678C12.4163 4.7199 12.5779 4.7199 12.7155 4.7678L23.5 8.54781C24.0868 8.73968 24.0868 9.50968 23.5 9.70156ZM22.6717 14.0598V11.4377L21.3069 11.8696V14.1013C21.039 14.2933 20.8534 14.6053 20.8534 14.9413C20.8534 15.5413 21.3873 16.0173 22.0299 16.0173C22.6717 16.0173 23.2064 15.5173 23.2064 14.9413C23.2064 14.5573 22.9914 14.2213 22.6717 14.0598ZM12.5315 15.0457C12.2947 15.0457 12.0587 15.0217 11.8459 14.9497L4.5044 12.603V17.7133C9.28649 20.8336 15.7523 20.8336 20.5335 17.7133V12.5766L12.8379 14.9233C12.5955 14.9953 12.3819 15.0457 12.5315 15.0457Z"
              fill="#747474"
            />
          </svg>
        ),
        label: "Level Up",
        ppDeprecated: true,
      },
];

const actions = allActions.filter(
  (action) => !isPPDeprecated || !action.ppDeprecated,
);
export const ActionsSection = () => {
  return (
    <SimpleGrid
      columns={{
        base: 2,
        lg: 4,
      }}
      w="full"
      gap={4}
    >
      {actions.map((action) => (
        <ActionCard key={action.href} {...action} />
      ))}
    </SimpleGrid>
  );
};

const ActionCard = ({ href, lottie, label, mobileIcon }: Action) => {
  return (
    <HoverCardWithLink
      href={href}
      showHoverIcon={false}
      linkProps={{ minH: ["auto", "auto", "184px"] }}
      cardRootStyles={{
        w: "full",
        rounded: ["12px", "12px", "3xl"],
      }}
    >
      <VStack hideFrom="md" gap={6} bgColor="#EFEEEB" p={6}>
        <Flex p={2.5} rounded="12px" bgColor="bg">
          {mobileIcon}
        </Flex>
        <Heading
          size="2xl"
          fontWeight="700"
          lineHeight="32px"
          letterSpacing="-0.47px"
        >
          {label}
        </Heading>
      </VStack>
      <AspectRatio ratio={277 / 184} hideBelow="md" bgColor="#EFEEEB">
        <LottieReact src={lottie} />
      </AspectRatio>
    </HoverCardWithLink>
  );
};
